import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLanguage32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLanguage32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 6h16v3.4a1 1 0 1 1-2 0V8h-5v13h2a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h2V8H5v1.4a1 1 0 1 1-2 0zm19.071 14.818.702-.468A5 5 0 0 0 25 16.19V14H15v-2h6v-2a1 1 0 1 1 2 0v2h6v2h-2v2.19a7 7 0 0 1-2.875 5.655l3.322 1.661a1 1 0 1 1-.894 1.789l-4.338-2.17-4.66 3.107-1.11-1.664 3.75-2.5A7 7 0 0 1 17 16.192V15.4h2v.792a5 5 0 0 0 2.764 4.472z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLanguage32);
